module.exports = __webpack_public_path__ + "fonts/Lato-HairlineItalic.d9cf5178.woff2";